import Registry from "../registry";
import React, { Component } from "react";
import utils from "../lib/utils";
import t from "tcomb-form";
import { connect } from "react-redux";
import { load as loadContent } from "../actions/content";
import ContentUtils from "../lib/ContentUtils";
import Select from "../components/fields/Select";
import MultiContentPicker from "../components/MultiContentPicker";
import CheckboxGroup from "../components/fields/CheckboxGroup";
import Loading from "../components/Loading";

const typesDispatched = [];

const hasDispatched = (type, data) => {
  if (Array.isArray(data)) return true;
  if (typesDispatched.indexOf(type.id) > -1) return true;

  typesDispatched.push(type.id);
  return false;
};

// Data Preload component
const relationshipPreload = Component => {
  @connect(({ sites: { current: site }, content, types }) => ({
    site,
    content,
    types
  }))
  class PreloadComponent extends Component {
    state = {
      types: [],
      store: []
    };

    static getDerivedStateFromProps(props, state) {
      const { dispatch, typeIds, types, content } = props;

      const nextState = {
        types: [],
        store: []
      };

      return typeIds.reduce(
        (nextState, typeId) => {
          const type = types.find(model => model.id === typeId);
          if (!type) return nextState;

          if (!hasDispatched(type, content[type.id])) {
            dispatch(loadContent(type));
            return nextState;
          }

          if (!Array.isArray(content[type.id])) return nextState;

          const storeData = content[type.id].map(item => ({
            ...item,
            _type: type
          }));

          return {
            ...nextState,
            types: [...nextState.types, type],
            store: [...nextState.store, ...storeData]
          };
        },
        { types: [], store: [] }
      );
    }

    render() {
      const { typeIds = [] } = this.props;
      if (typeIds.length > this.state.types.length) return <Loading />;

      return <Component {...this.props} {...this.state} />;
    }
  }

  return PreloadComponent;
};

@relationshipPreload
class Picker extends Component {
  getValue() {
    const { value } = this.props;

    // this should ALWAYS be an array
    // of objects, but just in case..
    return Array.isArray(value)
      ? value.map(v => (typeof v === "string" ? v : v.id))
      : [value];
  }

  render() {
    const { create, ...props } = this.props;
    const value = this.getValue();

    return <MultiContentPicker create={utils.isChecked(create)} {...props} />;
  }
}

@connect(state => ({ types: state.types, site: state.sites.current }))
class RelationshipType extends Component {
  render() {
    const { onChange, value, types, site } = this.props;

    return (
      <Select
        multiple
        value={value}
        onChange={onChange}
        options={site.groups.map(group => ({
          label: group.name,
          options: types
            .filter(type => type.group_id === group.id)
            .map(type => ({
              text: type.name,
              value: type.id
            }))
        }))}
      />
    );
  }
}

@relationshipPreload
class RenderItem extends Component {
  state = {
    values: []
  };

  static getDerivedStateFromProps(props, state) {
    return {
      values: [].concat(props.value).map(content => {
        const storeContent = props.store.find(c => c.id === content.id);
        return { content, type: storeContent._type };
      })
    };
  }

  render() {
    const { values } = this.state;

    return (
      <span>
        {values.map(({ content, type }) => (
          <span key={content.id}>
            {ContentUtils.renderContent(content, type)}
          </span>
        ))}
      </span>
    );
  }
}

const collection = {
  name: "Content Collection",
  group: "Relational",
  options: {
    relationship_types: {
      label: "Content types",
      type: "list",
      of: { type: "string" },
      factory: t.form.Textbox,
      config: { required: true },
      transformer: {
        format: v =>
          ((v && [].concat(v)) || []).map(v =>
            typeof v === "string" ? v : v.id
          ),
        parse: v => v
      },
      component: ({ onChange, value }) => (
        <RelationshipType onChange={onChange} typeIds={value} value={value} />
      )
    },
    limit: {
      label: "Limit",
      hint: "Maximum number of items. Default is no limit",
      type: "number"
    },
    creation: {
      label: "Allow item creation?",
      type: "boolean",
      default: true
    }
  },
  schema: part => ({
    type: "list",
    of: { type: "string" },
    factory: t.form.Textbox,
    transformer: {
      format: v =>
        ((v && [].concat(v)) || []).map(v =>
          typeof v === "string" ? v : v.id
        ),
      parse: v => v
    },
    component: ({ context, value, onChange }) => (
      <Picker
        fieldContext={context}
        create={part.creation}
        limit={part.limit}
        typeIds={part.relationship_types}
        onChange={onChange}
        value={value}
      />
    ),
    render: ({ value }) => (
      <RenderItem typeIds={part.relationship_types} value={value} />
    )
  })
};

Registry.register("collection", collection);

export default collection;



// WEBPACK FOOTER //
// ./app/parts/collection.js